//import mulLangTexts from './MulLangTexts.js';

export default class HelpSection {
  constructor() {
    this._elSection = document.querySelector('#helpSection');
    this._elContent = this._elSection.querySelector('.content');
    //this._elPointer = document.querySelector('.helpPointer');
    this._lastTarget = null;
    
    document.querySelector('#helpShowButton').addEventListener('click', () => {
      this._elSection.classList.remove('hidden');
    });
    this._elSection.querySelector('.close').addEventListener('click', () => {
      this._elSection.classList.add('hidden');
    });
    document.body.addEventListener('mouseover', e => {
      this._lastTarget = e.target;
      if(!this._elSection.classList.contains('hidden')) {
        this._update();
      }
    });
    /*this._elSection.querySelector('.pagination').addEventListener('click', e => {
      if(e.target.dataset.direction) {
        const {children} = this._elContent;
        let current;
        for(let i = 0; i < children.length; ++i) {
          const child = children[i];
          if(child.classList.contains('shown')) {
            child.classList.remove('shown');
            current = i;
            break;
          }
        }
        
        for(const child of e.currentTarget.children) {
          child.classList.remove('disabled');
        }
        
        switch(e.target.dataset.direction) {
        case 'prev':
          children[current - 1].classList.add('shown');
          this._updatePointer(children[current - 1]);
          if(current - 1 === 0) {
            e.target.classList.add('disabled');
          }
          break;
        case 'next':
          children[current + 1].classList.add('shown');
          this._updatePointer(children[current + 1]);
          if(current + 1 === children.length - 1) {
            e.target.classList.add('disabled');
          }
          break;
        }
      }
    });*/
  }
  localize(helps) {
    for(const el of this._elContent.children) {
      el.textContent = helps[el.dataset.name];
    }
  }
  toggle() {
    if(this._elSection.classList.contains('hidden')) {
      this._elSection.classList.remove('hidden');
      this._update();
    } else {
      this._elSection.classList.add('hidden');
    }
  }
  _update() {
    let target = this._lastTarget;
    while(!(target === null || (target.dataset && target.dataset.help !== undefined))) {
      target = target.parentElement;
    }
    if(target && target.dataset && target.dataset.help) {
      const elShown = this._elSection.querySelector('pre.shown');
      if(elShown.dataset.help !== target.dataset.help) {
        elShown.classList.remove('shown');
        const el = this._elSection.querySelector(`pre[data-name="${target.dataset.help}"]`);
        el.classList.add('shown');
      }
    }
  }
  get visible() {
    return this._elSection.classList.contains('hidden') ? 0 : 1;
  }
  set visible(v) {
    if(v == 0) {
      this._elSection.classList.add('hidden');
    } else {
      this._elSection.classList.remove('hidden');
    }
  }
  /*_updatePointer(element) {
    const selector = element.dataset.pointerSelector;
    if(selector) {
      const target = document.querySelector(selector);
      const rect = target.getBoundingClientRect();
      const direction = element.dataset.pointerDirection;

      this._elPointer.dataset.direction = direction;
      switch(direction) {
      case 'lower':
        this._elPointer.style.left = rect.x + rect.width / 2 + 'px';
        this._elPointer.style.top = rect.y + 'px';
        break;
      case 'upper':
      default:
        this._elPointer.style.left = rect.x + rect.width / 2 + 'px';
        this._elPointer.style.top = rect.y + rect.height + 'px';
        break;
      }
      this._elPointer.classList.add('shown');
    } else {
      this._elPointer.classList.remove('shown');
      this._elPointer.style.left = 0;
      this._elPointer.style.top = '100vh';
    }
  }*/
  /*init() {
    this._showText(this._getText('basic'));
    this._elSection.classList.remove('hidden');
    //this._elSection.addEventListener('transitionend', () => {
    //  this._updatePointer(this._elContent.firstElementChild);
    //}, {once: true});
  }
  error() {
    this._showText('Error');
  }*/
}
